import { Component, Input, inject } from '@angular/core';
import { CheckboxGroupComponent } from './checkbox-group.component';

@Component({
  selector: 'vb-checkbox',
  template: ` <div class="d-inline-block custom-checkbox">
    <label [for]="value" class="form-checkbox-element">
      <input
        type="checkbox"
        [checked]="isChecked()"
        class="custom mt-2"
        [id]="value"
        [disabled]="isDisabled() || disableField"
        (click)="toggleCheck()"
      />
      <span class="field-label pl-3" [innerHtml]="option"></span>
    </label>
    <ng-content></ng-content>
  </div>`,
  styleUrls: ['./checkbox-group.scss'],
  standalone: false  //NOSONAR
})
export class CheckboxComponent {
  private checkboxGroup = inject(CheckboxGroupComponent, { host: true });

  @Input() value: any;
  @Input() option: any;
  @Input() disableField = false;

  toggleCheck() {
    this.checkboxGroup.addOrRemove(this.value);
  }

  isChecked() {
    return this.checkboxGroup.contains(this.value);
  }

  isDisabled() {
    return this.checkboxGroup.disabled;
  }
}
